module.exports = __webpack_public_path__ + "img/wayne-teaching-tennis.84f98b8e.jpg";